export default __webpack_public_path__ + "static/media/Small_pets.6510bf4d.png";